import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { DIC } from '../../../../dic';
import { GN } from '../../../../../gn';

/**
 * Generated class for the OrderdelegatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-orderdelegate',
  templateUrl: 'orderdelegate.html',
})
export class OrderdelegatePage {
  drn: any;
  _path = []

  constructor(public toastCtrl: ToastController, public dic: DIC, public gn: GN, public navCtrl: NavController, public navParams: NavParams) {
    this.drn = this.navParams.get('drn')
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad OrderdelegatePage');
    this.loadPath()
  }

  loadPath() {
    var _that = this
    this.gn._Post('/api/gn/loadpath', { articleid: this.gn.crypt(this.drn.articleid), routeid: this.gn.crypt(this.drn.id) }, function (_data) {
      _that._path = _data.path
      for (var i = 0; i < _that._path.length; i++) {
        var _k = _that._path[i].pinusers.split('; ')
        _that._path[i].pinusersarr = []
        for (var k = 0; k < _k.length; k++) {
          _that._path[i].pinusersarr.push({ pid: _k[k].split('^')[0], fullname: _k[k].split('^')[1] })
        }
      }
    })
  }
  saveDelegate() {
    this.gn.tfBtn = true;
    var _sql = `delete from indoordelegate where routeid=` + this.drn.id + `;`;
    for (var i = 0; i < this._path.length; i++) {
      if (parseInt(this._path[i].selecteduser) != -1 && this._path[i].selecteduser != '-1' && this._path[i].selecteduser != "'-1'") {
        _sql += `
      insert into indoordelegate(clientid, userid, articleid, routeid, processid, userpinindoorid)
      values(`+ this.gn.user.ClientId + `, ` + this.gn.user.UserId + `, ` + this.drn.articleid + `, ` + this.drn.id + `, ` + this._path[i].pid + `, ` + parseInt(this._path[i].selecteduser) + `);
      `
      }
    }
    var _that = this
    this.gn._Post('/api/gn/saveroutedelegate', { sql: this.gn.crypt(_sql) }, function (_data) {
      _that.gn.tfBtn = false;

      _that.navCtrl.pop()

      var cb = _that.navParams.get('cb')
      cb();

      const toast = _that.toastCtrl.create({ message: _that.dic.l["succsaved1"], duration: 3000, position: 'top' });
      toast.present();
      return
    })
    // console.log('saveDelegate')
    // console.log(_sql)
    // debugger
  }
  test() {

  }
  setDelegate(e, _pobj) {
    _pobj.selecteduser = e
  }
}



// WEBPACK FOOTER //
// ./src/pages/routing/routeindoor/manageorders/orderdelegate/orderdelegate.ts